import api from '@/api/tecnologico.api'

let servicio = {}

servicio.clientesCon = () => {
  return api.get('/clientes/clientescon')
}

servicio.guardar = (data) => {
  return api.post('/clientes/guardarcliente', data)
}

servicio.cambiarEstatus = (data) => {
  return api.post('/clientes/cambiarstatuscliente', data)
}

export default servicio
